import React from "react";
import { useSelector } from "react-redux";
import { AFModal } from "./AdvanceFilters/AFModal";
import { AskTheTeamModal } from "./askTheTeamModal/AskTheTeamModal";
import DeleteQuestionModal from "./DeleteQuestionModal/DeleteQuestionModal";
import RequestForUpdateModal from "./RequestForUpdateModal/RequestForUpdateModal";
import ShareQuestionModal from "./ShareQuestionModal/ShareQuestionModal";
import FollowUpModal from "./FollowUpModal/FollowUpModal";
import SeekerAwardsModal from "./SeekerAwardsModal/SeekerAwardsModal";
import WatchlistOpenTabModal from "./WatchlistOpenTabModal/WatchlistOpenTabModal";
import FollowUpModal2 from "./RequestFolowUp/index";
import ProfilePictureModal from "./profilePictureModal/ProfilePictureModal";
import GenerativeResponse from "./GenerativeResponse/GenerativeResponse";
import AtomizerModal from "./AtomizerModal/AtomizerModal";
import RerouteModal from "./RerouteModal/RerouteModal";
import DeclineModal from "./DeclineModal/DeclineModal";
import ShareQuestionExpertOpenModal from "./ShareQuestionExpertOpenModal/ShareQuestionExpertOpenModal";
import { AddAttachment } from "./AddAttachmentModal/AddAttachment";
import RecentRatingsModal from "./RecentRatingsModal/RecentRatingsModal";
import QuesNotInQueue from "./QuesNotInQueue/QuesNotInQueue";
import SharedFolderCMModal from "./SharedFolderCMModal/SharedFolderCMModal";
import DataExportFilterModal from "./DeleteConfirmationModal/DataExportFilterModal";
import DeleteConfirmationModalGDrive from "./DeleteConfirmationModalGDrive/DeleteConfirmationModalGDrive";
import { DataExportModal } from "./CmDataExport/DataExportModal";
import PublishModal from "./PublishDocModal/PublishModal";
import DeleteDocModal from "./DeleteDocModal/deleteDocModal";
import { GenerteQModal } from "./GenerteQModal/GenerteQModal";
import OverwriteModal from "./OverWriteModal/OverwriteModal";
import DeleteMultiDocModal from "./DeleteMultiDocModal/deleteDocModal";
import PublishMultipleModal from "./PublishMultiDocModal/PublishMultipleModal";
import UnPublishMultipleModal from "./UnPublishMultiDocModal/PublishMultipleModal";
import { RFPUploadModal } from "./RFPUploadModal/RFPUploadModal";
import DeleteExpertRecordModal from "./DeleteExpertRecordModal/DeleteExpertRecordModal";
import TransferOwnershipBulk from "./TransferOwnershipBulk/TransferOwnershipBulk";
import RouteBackToExpert from "./RouteBackToExpert/RouteBackToExpert";
import CmCreateQA from "./cmCreateQA/CmCreateQA";
import ExpediteQuestionModal from "./ExpediteQuestion/ExpediteQuestionModal";
import DeleteCmAnswer from "./DeleteCmAnswer/DeleteCmAnswer";
import { TransferOwnershipSingle } from "./TransferOwnershipSingle/TransferOwnershipSingle";
import { RerouteCm } from "./RerouteCm/RerouteCm";
import { UpdateEmailQaPair } from "./UpdateEmailQaPair/updateEmailQaPair";
import RecommendQuestionsModal from "./RecommendQuestionsModal/RecommendQuestionsModal";
import { BriefAgentModal } from "./briefAgentModal/BriegAgentModal";
import BriefingModal from "./BrefingModal/BreifingModal";

export default function AllModals() {
  const modalState = useSelector((state) => state.domain);
  return (
    <>
      {modalState.modalName === "advanceFilter" && <AFModal />}
      {modalState.modalName === "askTheTeam" && <AskTheTeamModal />}
      {modalState.modalName === "requestForUpdate" && <RequestForUpdateModal />}
      {modalState.modalName === "shareQuestion" && <ShareQuestionModal />}
      {modalState.modalName === "followUpModal" && <FollowUpModal />}
      {modalState.modalName === "seekerAwardsModal" && <SeekerAwardsModal />}
      {modalState.modalName === "deleteQuestion" && <DeleteQuestionModal />}
      {modalState.modalName === "addToWatchlistOpenTab" && (
        <WatchlistOpenTabModal />
      )}
      {modalState.modalName === "followup2" && <FollowUpModal2 />}
      {modalState.modalName === "profilePicture" && <ProfilePictureModal />}
      {modalState.modalName === "generativeREsponse" && <GenerativeResponse />}
      {modalState.modalName === "atomizerResponse" && <AtomizerModal />}
      {modalState.modalName === "rerouteModal" && <RerouteModal />}
      {modalState.modalName === "expertDecline" && <DeclineModal />}
      {modalState.modalName === "expertOpen" && <ShareQuestionExpertOpenModal />}
      {modalState.modalName === "addAttachmentCaption" && <AddAttachment />}
      {modalState.modalName === "recentRatingsModal" && <RecentRatingsModal />}
      {modalState.modalName === "notInQueueModal" && <QuesNotInQueue />}
      {modalState.modalName === "sharedFoldersCM" && <SharedFolderCMModal />}
      {modalState.modalName === "dataExportFilter" && <DataExportFilterModal />}
      {modalState.modalName === "deleteGDriveConfirm" && <DeleteConfirmationModalGDrive />}
      {modalState.modalName === "cmDataExport" && <DataExportModal />}
      {modalState.modalName === "publishDoc" && <PublishModal />}
      {modalState.modalName === "deleteDoc" && <DeleteDocModal />}
      {modalState.modalName=='generateQ'&& <GenerteQModal/>}
      {modalState.modalName=='overwriteDoc'&& <OverwriteModal/>}
      {modalState.modalName=='deleteMultiDoc'&& <DeleteMultiDocModal/>}
      {modalState.modalName=='publishMultiDoc'&& <PublishMultipleModal/>}
      {modalState.modalName=='unpublishMultiDoc'&& <UnPublishMultipleModal/>}
      {modalState.modalName=='deleteexpertrecords'&& <DeleteExpertRecordModal/>}
      {modalState.modalName === "rfpMultiQ" && <RFPUploadModal />}
      {modalState.modalName === 'townershipBulk' && <TransferOwnershipBulk/>}
      {modalState.modalName === 'routebacktoexpertbulk' && <RouteBackToExpert/>}
      {modalState.modalName === 'createqapairexpertrecord' && <CmCreateQA/>}
      {modalState.modalName === 'expeditequestionmodal' && <ExpediteQuestionModal/>}
      {modalState.modalName === 'cmdeleteanswermodal' && <DeleteCmAnswer/>}
      {modalState.modalName === 'cmtransfersinglemodal' && <TransferOwnershipSingle/>}
      {modalState.modalName === 'reroutecm' && <RerouteCm/>}
      {modalState.modalName === 'cmIngestedEmailQaPair' && <UpdateEmailQaPair/>}
      {modalState.modalName === 'recommendModal' && <RecommendQuestionsModal />}
      {modalState.modalName === 'agentReview' && <BriefAgentModal />}
      {modalState.modalName==="breifingModal"&&<BriefingModal/>}
    </>
  );
}
